import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { CustomAvatarComponent } from "../custom-avatar/custom-avatar.component";
import { UserInitialsService } from '../../../core/services/user-initials.service';
import { UserDataService } from '../../../core/services/user-data.service';
import { ProfileImageService } from '../../../core/services/profile-image.service';
import { NotificationService } from '../../../core/services/notification.service';
import { CommonModule } from '@angular/common';
import { Notification } from '../../../core/interfaces/notifications-interface';
import { NotificationsPopupComponent } from "../notifications-popup/notifications-popup.component";


@Component({
  selector: 'app-desktop-topbar',
  standalone: true,
  imports: [CustomAvatarComponent, CommonModule, NotificationsPopupComponent],
  templateUrl: './desktop-topbar.component.html',
  styleUrl: './desktop-topbar.component.css'
})
export class DesktopTopbarComponent implements OnInit {
  constructor(private userInitialsService: UserInitialsService, private userData: UserDataService, private profileImage: ProfileImageService, private notificationService: NotificationService) { }

  @Input() pageName: string = ``;

  // User initials or image
  get userInitials(): string {
    return this.userInitialsService.getUserInitials(this.userData.getUser()?.first_name ?? '', this.userData.getUser()?.last_name ?? '');
  }

  get getProfileImage(): string | null {
    return this.profileImage.getProfileImage();
  }

  // Notifications
  showPopup = false;

  get notifications(): Notification[] {
    return this.notificationService.getListOfNotifications();
  }

  get unreadCount(): number {
    return this.notificationService.getUnreadNotificationsCount();
  }

  get waitingForNextPage(): boolean {
    return this.notificationService.getWaitingForNextPage();
  }

  @ViewChild('popupContainer', { static: true }) popupRef!: ElementRef;

  ngOnInit(): void {
    this.notificationService.connect();
  }

  togglePopup() {
    if (!this.showPopup && this.notifications.length <= 0) {
      return;
    }

    this.showPopup = !this.showPopup;
  }

  markAsRead(id: string) {
    const notification = this.notifications.find(n => n.id === id);
    if (notification && !notification.is_read) {
      notification.is_read = true;

      this.notificationService.sendSetAsRead(notification.id, true)
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.popupRef && !this.popupRef.nativeElement.contains(event.target)) {
      this.showPopup = false;
    }
  }

  loadMoreCallback = () => {
    this.notificationService.requestNewPage();
  };

}
